<template>
  <div class="poll-warpper">
    <div class="bg-white">
      <threeLevel @SearchInfo="SearchInfo"/>
      <div class="flex align-center justify-between flex-wrap margin-top-sm">
        <div class="poll-item">
          <div class="item-title active1"><img src="../../assets/img/my1.png" alt="">户数调查</div>
          <div class="item-info">
            <div class="item-num">
              <p>合计户数</p>
              <h3>{{ zongHuShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>整体同意(户)</p>
              <h3>{{ tongYiHuShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>同意率</p>
              <h3>{{ tongYiBiLvZongGai }}%</h3>
            </div>
          </div>
        </div>
        <div class="poll-item">
          <div class="item-title active2"><img src="../../assets/img/my2.png" alt="">串数调查</div>
          <div class="item-info">
            <div class="item-num">
              <p>合计串数</p>
              <h3>{{ zongChuanShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>串同意（串)</p>
              <h3>{{ tongYiChuanShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>同意率</p>
              <h3>{{ tongYiBiLvChuan }}%</h3>
            </div>
          </div>
        </div>
        <div class="poll-item">
          <div class="item-title active3"><img src="../../assets/img/my3.png" alt="">单元调查</div>
          <div class="item-info">
            <div class="item-num">
              <p>合计单元</p>
              <h3>{{ zongDanYuanShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>单元同意（单元）</p>
              <h3>{{ tongYiDanYuanShu }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>同意率</p>
              <h3>{{ tongYiBiLvDanYuan }}%</h3>
            </div>
          </div>
        </div>
        <div class="poll-item">
          <div class="item-title active4"><img src="../../assets/img/my4.png" alt="">未取得联系</div>
          <div class="item-info">
            <div class="item-num">
              <p>未取得联系</p>
              <h3>{{ weiQuDeLianXi }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>占比</p>
              <h3>{{ weiQuDeLianXiBiLv }}%</h3>
            </div>
          </div>
        </div>
        <div class="poll-item">
          <div class="item-title active5"><img src="../../assets/img/my5.png" alt="">+改造+物业 </div>
          <div class="item-info">
            <div class="item-num">
              <p>调查户数</p>
              <h3>{{ jiaWuYeJiaGaiZao }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>同意率</p>
              <h3>{{ jiaWuYeJiaGaiZaoBiLv }}%</h3>
            </div>
          </div>
        </div>
        <div class="poll-item">
          <div class="item-title active6"><img src="../../assets/img/my6.png" alt="">+改造-物业 </div>
          <div class="item-info">
            <div class="item-num">
              <p>调查户数</p>
              <h3>{{ jiaGaiZaoJianWuYe }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>同意率</p>
              <h3>{{ jiaGaiZaoJianWuYeBiLv }}%</h3>
            </div>
          </div>
        </div>
        <div class="poll-item">
          <div class="item-title active7"><img src="../../assets/img/my7.png" alt="">-改造+物业 </div>
          <div class="item-info">
            <div class="item-num">
              <p>调查户数</p>
              <h3>{{ jianGaiZaoJiaWuYe }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>同意率</p>
              <h3>{{ jianGaiZaoJiaWuYeBiLv }}%</h3>
            </div>
          </div>
        </div>
        <div class="poll-item">
          <div class="item-title active8"><img src="../../assets/img/my8.png" alt="">-改造-物业 </div>
          <div class="item-info">
            <div class="item-num">
              <p>调查户数</p>
              <h3>{{ jianGaiZaoJianWuYe }}</h3>
            </div>
            <i></i>
            <div class="item-num">
              <p>同意率</p>
              <h3>{{ jianGaiZaoJianWuYeBiLv }}%</h3>
            </div>
          </div>
        </div>
      </div>
      <div v-if="buildingList.length>0">
        <div class="flex align-center justify-end margin-tb">
          <div class="tagging-item"><i class="active1"></i> <span>同意改造+已签署物业合同</span></div>
          <div class="tagging-item"><i class="active2"></i> <span>同意改造+未签署物业合同</span></div>
          <div class="tagging-item"><i class="active3"></i> <span>不同意改造+已签署物业合同</span></div>
          <div class="tagging-item"><i class="active4"></i> <span>不同意改造+未签署物业合同</span></div>
          <div class="tagging-item"><i class="active5"></i> <span>未取得联系</span></div>
        </div>
        <div v-for="building in buildingList" :key="building.id">
          <div class="font-size flex align-center justify-between building-name "
               @click="building.open = !building.open">
            <h3>{{ building.building_name }}分布图 <span>（{{ building.element_list.length }}个单元）</span></h3>
            <p class="margin-left">{{ building.open ? '收起' : '展开' }}</p>
          </div>

          <div class="" v-if="building.open">
            <div class="w-100 padding-tb-xs" v-for="item in building.element_list" :key="item.id">
              <div class="unit-scroll flex align-start flex-wrap">
                <div class="  unit-box"
                     :style="{width:(item.chuan_index*150+1) + 'px'} ">
                  <div class="flex align-center">
                    <div v-for="(chuan,cindex) in item.chuan_index" :key="cindex" class="unit-item active"
                         style="width: 150px">
                      {{ chuan }}串
                    </div>
                  </div>
                  <div class="flex align-center flex-wrap">
                    <div v-for="room in item.room_list" :key="room.id" class="unit-item" style="width: 150px">
                      <p>{{ building.building_name + '-' + item.element_name + '-' + room.room_name }}</p>
                      <i class="active1" v-if="room.wuyehetong === 3 && room.zonggai === 3"></i>
                      <i class="active2" v-if="room.wuyehetong !== 3 && room.zonggai === 3"></i>
                      <i class="active3" v-if="room.wuyehetong === 3 && room.zonggai !== 3"></i>
                      <i class="active4" v-if="room.wuyehetong === 2 && room.zonggai === 2"></i>
                      <i class="active5" v-if="room.wuyehetong === 1 && room.zonggai === 1"></i>
                    </div>
                  </div>
                  <div class="unit-name">{{ item.element_name }}</div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import threeLevel from '@/components/three-level'
import {minYiDiaoChaOne, minYiDiaoChaTwo} from "@/api/statistics";

export default {
  name: "poll",
  data() {
    return {
      jiaGaiZaoJianWuYeBiLv: 0,
      jiaWuYeJiaGaiZaoBiLv: 0,
      jianGaiZaoJiaWuYeBiLv: 0,
      jianGaiZaoJianWuYeBiLv: 0,
      jiaGaiZaoJianWuYe: 0,
      jiaWuYeJiaGaiZao: 0,
      jianGaiZaoJiaWuYe: 0,
      jianGaiZaoJianWuYe: 0,
      tongYiBiLvChuan: 0,
      tongYiBiLvDanYuan: 0,
      tongYiBiLvZongGai: 0,
      tongYiChuanShu: 0,
      tongYiDanYuanShu: 0,
      tongYiHuShu: 0,
      weiQuDeLianXi: 0,
      weiQuDeLianXiBiLv: 0,
      zongChuanShu: 0,
      zongDanYuanShu: 0,
      zongHuShu: 0,
      buildingList: []
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "物业统计", false);
  },
  components: {
    threeLevel
  },
  methods: {
    async SearchInfo(val) {
      let _data = await minYiDiaoChaOne(
          val.project,
          val.community,
          val.yuangong
      )
      this.jiaGaiZaoJianWuYeBiLv = (_data.data.jiaGaiZaoJianWuYeBiLv * 100).toFixed(2)
      this.jiaWuYeJiaGaiZaoBiLv = (_data.data.jiaWuYeJiaGaiZaoBiLv * 100).toFixed(2)
      this.jianGaiZaoJiaWuYeBiLv = (_data.data.jianGaiZaoJiaWuYeBiLv * 100).toFixed(2)
      this.jianGaiZaoJianWuYeBiLv = (_data.data.jianGaiZaoJianWuYeBiLv * 100).toFixed(2)
      this.jiaGaiZaoJianWuYe = _data.data.jiaGaiZaoJianWuYe
      this.jiaWuYeJiaGaiZao = _data.data.jiaWuYeJiaGaiZao
      this.jianGaiZaoJiaWuYe = _data.data.jianGaiZaoJiaWuYe
      this.jianGaiZaoJianWuYe = _data.data.jianGaiZaoJianWuYe
      this.tongYiBiLvChuan = (_data.data.tongYiBiLvChuan * 100).toFixed(2)
      this.tongYiBiLvDanYuan = (_data.data.tongYiBiLvDanYuan * 100).toFixed(2)
      this.tongYiBiLvZongGai = (_data.data.tongYiBiLvZongGai * 100).toFixed(2)
      this.tongYiChuanShu = _data.data.tongYiChuanShu
      this.tongYiDanYuanShu = _data.data.tongYiDanYuanShu
      this.tongYiHuShu = _data.data.tongYiHuShu
      this.weiQuDeLianXi = _data.data.weiQuDeLianXi
      this.weiQuDeLianXiBiLv = (_data.data.weiQuDeLianXiBiLv * 100).toFixed(2)
      this.zongChuanShu = _data.data.zongChuanShu
      this.zongDanYuanShu = _data.data.zongDanYuanShu
      this.zongHuShu = _data.data.zongHuShu
      if (val.community) {
        let _list = await minYiDiaoChaTwo(val.project, val.community, val.yuangong)
        _list.data.map(item=>{
          item.open = true
        })
        this.buildingList = _list.data
      } else {
        this.buildingList = []
      }
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

.poll-warpper {
  .poll-item {
    flex-basis: 24%;
    height: 170px;
    margin-bottom: 20px;
    background-color: #ffffff;
    box-shadow: 0px 0px 19px 0px rgba(175, 181, 193, 0.47);
    border-radius: 8px;

    .item-title {
      display: flex;
      align-items: center;
      padding-left: 20px;
      height: 40px;
      font-size: 18px;
      color: #fff;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;

      &.active1 {
        background-color: #1bb2cd;
      }

      &.active2 {
        background-color: #ffaf25;
      }

      &.active3 {
        background-color: #42922a;
      }

      &.active4 {
        background-color: #616161;
      }

      &.active5 {
        background-color: #1bb2cd;
      }

      &.active6 {
        background-color: #bf984c;
      }

      &.active7 {
        background-color: #2587ff;
      }

      &.active8 {
        background-color: #e15757;
      }

      img {
        margin-right: 10px;
      }
    }

    .item-info {
      display: flex;
      align-items: center;
      height: 130px;

      &.total-all {
        justify-content: center;
        font-size: 16px;

        b {
          font-size: 32px;
          margin-right: 5px;
        }
      }

      .item-num {
        width: 48%;
        min-height: 52px;
        text-align: center;

        p {
          font-size: 14px;
          color: #999;
          line-height: 150%;
        }

        h3 {
          font-size: 24px;
          line-height: 150%;
        }
      }

      i {
        display: block;
        width: 1px;
        height: 52px;
        border: dashed 1px #cccccc;
        opacity: 0.5;
      }
    }
  }

  .tagging-item {
    display: flex;
    align-items: center;
    margin-left: 30px;

    i {
      display: block;
      width: 10px;
      height: 10px;
      border-radius: 10px;
      margin-right: 10px;

      &.active1 {
        background-color: #52b72f;
      }

      &.active2 {
        background-color: #bf984c;
      }

      &.active3 {
        background-color: #2587ff;
      }

      &.active4 {
        background-color: #e36161;
      }

      &.active5 {
        background-color: #616161;
      }
    }
  }

  .building-name {
    cursor: pointer;
    padding: 10px;

    span {
      font-weight: normal;
      color: #999;
      font-size: 14px;
    }

    p {
      color: #d00000;
      font-weight: normal;
      font-size: 14px;
    }
  }

  .unit-scroll {
    width: 100%;
    overflow: auto;

    .unit-box {
      border-top: 1px solid #eee;
      border-left: 1px solid #eee;
      box-sizing: border-box;

      .unit-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 150px;
        height: 50px;
        padding: 0 10px;
        box-sizing: border-box;
        border-right: 1px solid #eee;
        border-bottom: 1px solid #eee;

        &.active {
          background: #eee;
          justify-content: center;
        }

        p {
          flex: 1;
          text-align: center;
        }

        i {
          display: block;
          width: 10px;
          height: 10px;
          border-radius: 10px;

          &.active1 {
            background-color: #52b72f;
          }

          &.active2 {
            background-color: #bf984c;
          }

          &.active3 {
            background-color: #2587ff;
          }

          &.active4 {
            background-color: #e36161;
          }

          &.active5 {
            background-color: #616161;
          }
        }
      }

      .unit-name {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 50px;
        color: #d00000;
        border: 1px solid #eeee;
        border-top: 0;
        font-weight: bold;
      }
    }
  }
}
</style>
